package com.gloopgo.game.ui

import androidx.compose.runtime.Composable
import com.gloopgo.game.engine.AnimalSkinOption
import gloopgo.shared.generated.resources.*
import org.jetbrains.compose.resources.StringResource
import org.jetbrains.compose.resources.stringResource

fun AnimalSkinOption.nameResOrNull(): StringResource? = when (id) {
    "dragon" -> Res.string.skin_dragon
    "drake" -> Res.string.skin_drake
    "trex" -> Res.string.skin_trex
    "sauropod" -> Res.string.skin_sauropod
    "shark" -> Res.string.skin_shark
    "dolphin" -> Res.string.skin_dolphin
    "whale" -> Res.string.skin_whale
    "octopus" -> Res.string.skin_octopus
    "squid" -> Res.string.skin_squid
    "crab" -> Res.string.skin_crab
    "lion" -> Res.string.skin_lion
    "tiger" -> Res.string.skin_tiger
    "leopard" -> Res.string.skin_leopard
    "fox" -> Res.string.skin_fox
    "wolf" -> Res.string.skin_wolf
    "bear" -> Res.string.skin_bear
    "panda" -> Res.string.skin_panda
    "koala" -> Res.string.skin_koala
    "gorilla" -> Res.string.skin_gorilla
    "monkey" -> Res.string.skin_monkey
    "elephant" -> Res.string.skin_elephant
    "rhino" -> Res.string.skin_rhino
    "hippo" -> Res.string.skin_hippo
    "giraffe" -> Res.string.skin_giraffe
    "zebra" -> Res.string.skin_zebra
    "unicorn" -> Res.string.skin_unicorn
    "eagle" -> Res.string.skin_eagle
    "owl" -> Res.string.skin_owl
    "flamingo" -> Res.string.skin_flamingo
    "parrot" -> Res.string.skin_parrot
    "peacock" -> Res.string.skin_peacock
    "bat" -> Res.string.skin_bat
    "butterfly" -> Res.string.skin_butterfly
    "bee" -> Res.string.skin_bee
    "frog" -> Res.string.skin_frog
    "turtle" -> Res.string.skin_turtle
    "snake" -> Res.string.skin_snake
    "crocodile" -> Res.string.skin_crocodile
    "hedgehog" -> Res.string.skin_hedgehog
    "bunny" -> Res.string.skin_bunny
    "cat" -> Res.string.skin_cat
    "dog" -> Res.string.skin_dog
    "pig" -> Res.string.skin_pig
    "cow" -> Res.string.skin_cow
    "duck" -> Res.string.skin_duck
    "hamster" -> Res.string.skin_hamster
    "chick" -> Res.string.skin_chick
    "penguin" -> Res.string.skin_penguin
    "phoenix" -> Res.string.skin_phoenix
    else -> null
}

@Composable
fun AnimalSkinOption.localizedName(): String {
    val res = nameResOrNull()
    return if (res != null) stringResource(res) else name
}
